/**
 * Created by m.igrachev on 7/21/2017.
 */
import isEmail from "../isEmail";
import isAlpha from "../isAlpha";
import isAlphanumeric from "../isAlphanumeric";
import isDecimal from "../isDecimal";
import isNumeric from "../isNumeric";
import isLowercase from "../isLowercase";
import isUppercase from "../isUppercase";
import maxSize from "../maxSize";
import minSize from "../minSize";
import maxCount from "../maxCount";
import validateWithExpression from "../validateWithExpression";
import requiredValidate from "../requiredValidate";
import isInRange from "../isInRange";
import isIBAN from "../isIBAN";
import isDateInRange from "../isDateInRange";
import fileExtension from "../fileExtension";

export default {
    alpha: isAlpha,
    alphaNumeric: isAlphanumeric,
    eMail: isEmail,
    decimal: isDecimal,
    lowercase: isLowercase,
    numeric: isNumeric,
    regExp: validateWithExpression,
    required: requiredValidate,
    uppercase: isUppercase,
    maxSize: maxSize,
    minSize: minSize,
    maxCount: maxCount,
    range: isInRange,
    isIBAN: isIBAN,
    dateRange: isDateInRange,
    fileExtension: fileExtension
};
